<template>
  <div class="layout-box">
    <div class="router-view-wrapper">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
    <div class="custom-tabbar">
      <div
          class="tabbar-item"
          :class="{ active: active === 'features' }"
          @click="navigateTo('/features')"
      >
        <van-icon
            class="iconfont icon-menu-fuliaocangku"
            size="22"
            :color="active === 'features' ? '#409eff' : '#999'"
        />
        <span style="font-weight: 600">WMS管理</span>
      </div>
      <div
          class="tabbar-item"
          :class="{ active: active === 'approval' }"
          @click="navigateTo('/approval')"
      >
        <van-icon
            class="iconfont icon-shenhe1"
            size="22"
            :color="active === 'approval' ? '#409eff' : '#999'"
        />
        <span style="font-weight: 600">审批管理</span>
      </div>
      

    </div>

  </div>
</template>

<script>
export default {
  name: "LayoutPage",
  data() {
    return {
      active: ""
    };
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(path) {
        if (path.includes("approval")) {
          this.active = "approval";
        } else if (path.includes("features")) {
          this.active = "features";
        }
      }
    }
  },

  methods: {
    navigateTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped lang="scss">

.layout-box {
  width: 100%;
  min-height:100%;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
}

/* 页面区域 */
.router-view-wrapper {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* 底部导航 */
.custom-tabbar {
  height: 50px;
  background: #fff;
  display: flex;
  border-top: 1px solid #eee;
  justify-content: space-around;
  align-items: center;
  z-index: 3;
}

/* tab item */
.tabbar-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tabbar-item span {
  font-size: 12px;
  color: #999;
}

.tabbar-item.active span {
  color: #409eff;
}

</style>